export default "__VITE_PUBLIC_ASSET__ae25d189__"